<template>
  <section
    :id="module.id"
    class="hiring-process"
    :style="[hiringProcessElStyles]"
    :class="templateClass"
  >
    <GlobalUIMedia
      v-if="module.config.general.showMedia"
      :media="module.config.general.media"
      :lazy="lazy"
    />
    <component
      :is="module.config.general.template.component"
      :module="module"
      :style="modulePadding"
    />
  </section>
</template>

<script>
import hiringProcessModule from "./hiringProcessDefaultModuleProp.js";
import { globalComputed, globalMethods } from "../../GlobalUI/mixins/global.js";
import HiringProcessHorizontal from "./Templates/HiringProcessHorizontal.vue";
import HiringProcessVertical from "./Templates/HiringProcessVertical.vue";
import GlobalUIMedia from "../../GlobalUI/GlobalUIMedia.vue";

export default {
  name: "HiringProcess",
  mixins: [globalComputed, globalMethods],
  components: {
    HiringProcessHorizontal,
    HiringProcessVertical,
    GlobalUIMedia,
  },
  props: {
    module: {
      type: Object,
      default() {
        return hiringProcessModule;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hiringProcessElStyles() {
      const { moduleBackgroundColor } = this.module.config.general;

      const styles = {
        backgroundColor: moduleBackgroundColor.value,
      };

      return styles;
    },
    templateClass() {
      return (
        "-" +
        this.module.config.general.template.component.slice(13).toLowerCase()
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@include reset;

.hiring-process {
  container-type: inline-size;
  contain: layout;
}
</style>
